import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  version: {
    cursor    : 'default',
    marginLeft: theme.spacing(1),
  },
}));